import storeConfig from 'Stores/tkhuby6608-1806897/config';

try {
  storeConfig.InitFunc?.();
} catch (e) {
  console.error(e);
  import('Diagnostics/diagnostics')
    .then(({ logRuntimeError }) => logRuntimeError({ source: 'init_func', error: e }))
    .catch(() => {});
}
